import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import type { ResumeClarity } from "@jobreel/shared";

export interface ActiveResume {
  clarity?: ResumeClarity | null;
  // (other resume fields exist on the response; the clarity callout only needs this)
}

/** The user's active resume, including the optional clarity summary. Shared key so
 *  it dedupes across pages; retry:false so a 404 (no resume) fails fast. */
export function useActiveResume() {
  return useQuery<ActiveResume>({
    queryKey: ["resume", "active"],
    queryFn: async () => {
      const { data } = await axios.get<ActiveResume>("/api/resumes/active");
      return data;
    },
    retry: false,
  });
}
